import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DeleteReasonPage } from './delete-reason.page';

const routes: Routes = [
  {
    path: '',
    component: DeleteReasonPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DeleteReasonPageRoutingModule {}
